import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/Kviz.module.scss'

import { Container, Button, Image, ProgressBar, FloatingLabel, Form, Row, Col } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'
import SimleForm from './SimleForm'

class Kviz extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      step: 1,
      kv_1: -1,
      kv_1_text: ``,
      kv_2: -1,
      kv_2_text: ``,
      kv_3_text: ``,
      kv_4_text: ``,
      height: 3000,
      width: 1200,
      show_feedback: false
    }
  }

  changeStep = ( step ) => {
    this.setState({
      step: step < 1 ? 1 : ( step > 4 ? 4 : step )
    })
  }

  c_kv_1 = ( k, text ) => {
    this.setState({
      kv_1: k,
      kv_1_text: text
    })
  }
  c_kv_2 = ( k, text ) => {
    this.setState({
      kv_2: k,
      kv_2_text: text
    })
  }

  handleMaterialChange = (field, value) => {
    this.setState({
      [field]: value
    })
  }

  handleDimensionChange = (field, value) => {
    // Убедимся, что значение - число
    const numericValue = value.replace(/\D/g, '');
    this.setState({
      [field]: numericValue,
      [`${field}_text`]: numericValue
    })
  }

  openFeedback = () => {
    this.setState({
      show_feedback: true
    })
  }

  closeFeedback = () => {
    this.setState({
      show_feedback: false
    })
  }

  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  formatSlideNumber2 = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `${index < 10 ? '0' + index : index}`
  }

  render() {

    const { data, assets_path } = this.props,
    { step, kv_1, kv_1_text, kv_2, kv_2_text, kv_3_text, kv_4_text, height, width, show_feedback } = this.state

    return (
      <section className={`${styles.section}`}>
        <Container>
          <WhiteBlockTitle
            title={data?.title || ``}
            className={styles.title}
          />
          <div className={styles.kviz}>
            <div className={styles.kviz_top}>
              <div className={styles.kviz_top_text}>
                <Image src={`/${assets_path}/images/calculator.svg`} alt="P" width={18} height={20} />
                <div>Выберите тип лестницы, тип основания, материалы и размеры - введите номер телефона и нажмите узнайте стоимость!</div>
              </div>
              <div>[{this.formatSlideNumber2(step)}/04]</div>
            </div>
            <ProgressBar className={styles.kviz_progress} now={step / 4 * 100} />
            <div className={styles.kviz_content}>
              {step == 1 &&
                <>
                  <div className={styles.kviz_content_top}>
                    <div className={styles.kviz_content_ttitle}>Какой тип лестницы вам нужен?</div>
                    <div>Доступен один из вариантов ответа</div>
                  </div>
                  <div className={styles.kviz_content_items}>
                    {data?.list_1.map( ( elm, k ) => (
                      <div
                        onClick={() => this.c_kv_1( k, elm?.name )}
                        className={kv_1 == k ? styles.kviz_content_items_el_active : styles.kviz_content_items_el}
                        key={k}
                      >
                        <div className={styles.kviz_content_items_el_num}>{this.formatSlideNumber(k)}</div>
                        <div className={styles.kviz_content_items_el_image}>
                          <Image src={elm?.image} width={61} height={60} alt={elm?.name} />
                        </div>
                        <div className={styles.kviz_content_items_el_name}>{elm?.name}</div>
                      </div>
                    ))}
                  </div>
                </>
              }
              {step == 2 &&
                <>
                  <div className={styles.kviz_content_top}>
                    <div className={styles.kviz_content_ttitle}>Какой тип основания?</div>
                    <div>Доступен один из вариантов ответа</div>
                  </div>
                  <div className={styles.kviz_content_items}>
                    {data?.list_2.map( ( elm, k ) => (
                      <div
                        onClick={() => this.c_kv_2( k, elm?.name )}
                        className={kv_2 == k ? styles.kviz_content_items_el_active : styles.kviz_content_items_el}
                        key={k}
                      >
                        <div className={styles.kviz_content_items_el_num}>{this.formatSlideNumber(k)}</div>
                        <div className={styles.kviz_content_items_el_image}>
                          <Image src={elm?.image} width={61} height={60} alt={elm?.name} />
                        </div>
                        <div className={styles.kviz_content_items_el_name}>{elm?.name}</div>
                      </div>
                    ))}
                  </div>
                </>
              }
              {step == 3 &&
                <>
                  <div className={styles.kviz_content_top}>
                    <div className={styles.kviz_content_ttitle}>Выберите материал?</div>
                    <div />
                  </div>
                  <div className={styles.kviz_content_selects}>
                    <Row>
                      <Col lg={6}>
                        <FloatingLabel controlId="floatingSelect1" label="Материал для ступеней" className="mb-2">
                          <Form.Select 
                            aria-label="Материал для ступеней"
                            value={kv_3_text}
                            onChange={(e) => this.handleMaterialChange('kv_3_text', e.target.value)}
                          >
                            {data?.list_3.map( ( elm, k ) => (
                              <option key={k} value={elm?.name}>{elm?.name}</option>
                            ))}
                          </Form.Select>
                        </FloatingLabel>
                        <FloatingLabel controlId="floatingSelect2" label="Материал для перил">
                          <Form.Select 
                            aria-label="Материал для перил"
                            value={kv_4_text}
                            onChange={(e) => this.handleMaterialChange('kv_4_text', e.target.value)}
                          >
                            {data?.list_3.map( ( elm, k ) => (
                              <option key={k} value={elm?.name}>{elm?.name}</option>
                            ))}
                          </Form.Select>
                        </FloatingLabel>
                      </Col>
                      <Col lg={6}>
                        <FloatingLabel
                          controlId="floatingInput1"
                          label="Высота лестницы mm"
                          className="mb-2"
                        >
                          <Form.Control 
                            type="text" 
                            value={height} 
                            onChange={(e) => this.handleDimensionChange('height', e.target.value)}
                          />
                        </FloatingLabel>
                        <FloatingLabel
                          controlId="floatingInput2"
                          label="Ширина лестницы mm"
                        >
                          <Form.Control 
                            type="text" 
                            value={width} 
                            onChange={(e) => this.handleDimensionChange('width', e.target.value)}
                          />
                        </FloatingLabel>
                      </Col>
                    </Row>
                  </div>
                </>
              }
              {step == 4 &&
                <>
                  <div className={styles.kviz_content_top}>
                    <div className={styles.kviz_content_ttitle}>Отправьте заявку на расчет стоимости?</div>
                    <div />
                  </div>
                  <div className={styles.kviz_content_form}>
                    <SimleForm
                      btn={`Раcсчитайте стоимость вашей лестницы`}
                      assets_path={assets_path}
                      width={233}
                      name={true}
                      onSubmit={this.openFeedback}
                      data={[
                        { name: `Тип лестницы`, value: kv_1_text },
                        { name: `Тип основания`, value: kv_2_text },
                        { name: `Материал для ступеней`, value: kv_3_text },
                        { name: `Материал для перил`, value: kv_4_text },
                        { name: `Высота лестницы`, value: height },
                        { name: `Ширина лестницы`, value: width }
                      ]}
                    />
                  </div>
                </>
              }
            </div>
            <div className={styles.kviz_bottom}>
              <Button onClick={() => this.changeStep( step - 1 )} className={styles.kviz_bottom_btn} variant={`light`}>
                <div className={styles.kviz_bottom_btn_icon}>
                  <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.3211 4.49913H1.6787M1.6787 4.49913L5.53564 8.35608M1.6787 4.49913L5.53564 0.642184" stroke="black" strokeLinecap="round"/>
                  </svg>
                </div>
                <div className={styles.kviz_bottom_btn_text}>Назад</div>
              </Button>
              <Button onClick={() => this.changeStep( Number(step) + 1 )} className={styles.kviz_bottom_btn} variant={`light`}>
                <div className={styles.kviz_bottom_btn_icon}>
                  <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.678756 4.50087H10.3211M10.3211 4.50087L6.46418 0.643924M10.3211 4.50087L6.46418 8.35782" stroke="#00C775" strokeLinecap="round"/>
                  </svg>
                </div>
                <div className={styles.kviz_bottom_btn_text}>Вперед</div>
              </Button>
            </div>
          </div>
        </Container>
      </section>
    )
  }
}

Kviz.propTypes = {
  data: PropTypes.object,
  assets_path: PropTypes.string
}

Kviz.defaultProps = {
  data: {},
  assets_path: ``
}

export default Kviz